export const SET_TRACKS = 'SET_TRACKS';
export const ADD_TRACKS = 'ADD_TRACKS';
export const SET_ALBUMS = 'SET_ALBUMS';
export const ADD_ALBUMS = 'ADD_ALBUMS';
export const SET_ARTISTS = 'SET_ARTISTS';
export const ADD_ARTISTS = 'ADD_ARTISTS';